import { render } from "./BarChartRight.vue?vue&type=template&id=2f08657e"
import script from "./BarChartRight.vue?vue&type=script&lang=ts"
export * from "./BarChartRight.vue?vue&type=script&lang=ts"
script.render = render

export default script